











































import { AppVersion } from "@/common/utils";
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
const auth = namespace("Auth");

@Component({
  name: "QNav",
  components: {},
})
export default class QNav extends Vue {
  @auth.Action
  logout!: () => void;

  public appVersion = AppVersion();
}
